import Pathway from 'components/Pathway/Pathway'
import Footer from 'components/shared/Footer/Footer'
import HtmlHead from 'components/shared/HtmlHead/HtmlHead'
import Loader from 'components/shared/Loader/Loader'
import NoMatch from 'components/shared/NoMatch/NoMatch'
import SiteHeader from 'components/shared/SiteHeader/SiteHeader'
import { withRouter } from 'helpers/withRouter'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { withCookies } from 'react-cookie'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import {
  fetchPathway,
  fetchPathwayProjects,
} from 'redux/actions/PathwayActions'

const PathwayContainer = ({
  dispatch,
  i18n,
  pathway,
  projects,
  user,
  cookies,
  router: {
    params: { slug },
  },
}) => {
  const [loadProjects, setLoadProjects] = useState(true)
  const [theme, setTheme] = useState('default')

  const { currentLocale } = projects

  useEffect(() => {
    if (currentLocale !== i18n.language) {
      setLoadProjects(true)
    }
    if (loadProjects) {
      const access_token = user ? user.access_token : null
      dispatch(fetchPathway(i18n.language, slug))
      dispatch(
        fetchPathwayProjects(
          i18n.language,
          slug,
          access_token,
          cookies.cookies.sessionProgress
        )
      )
      setLoadProjects(false)
    }
  }, [
    dispatch,
    slug,
    user,
    currentLocale,
    i18n.language,
    loadProjects,
    cookies.cookies.sessionProgress,
  ])

  useEffect(() => {
    if (pathway?.themes && Array.isArray(pathway?.themes)) {
      setTheme(pathway.themes[0]?.name)
    }
  }, [loadProjects, pathway])

  return (
    <div>
      <HtmlHead
        title={pathway.metaTitle}
        description={pathway.metaDescription}
      />
      <SiteHeader locale={i18n.language} />
      <Loader display={pathway.loading || projects.loading} />
      <NoMatch error={pathway.error || projects.error} />
      {!(pathway.loading || projects.loading) && (
        <>
          <Pathway
            locale={i18n.language}
            pathway={pathway}
            projects={projects}
            theme={theme}
            user={user}
          />
          <Footer
            text="project.footer.feedback.homepage.text"
            userID="pathway-footer-user-id"
          />
        </>
      )}
    </div>
  )
}

PathwayContainer.propTypes = {
  cookies: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    language: PropTypes.string.isRequired,
  }).isRequired,
  pathway: PropTypes.object.isRequired,
  projects: PropTypes.object.isRequired,
  router: PropTypes.shape({
    params: PropTypes.shape({
      slug: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  user: PropTypes.object,
}

const mapStateToProps = (state) => {
  const { projects, pathway, authentication } = state
  return {
    projects,
    pathway,
    user: authentication.user,
  }
}

export { PathwayContainer }
export default connect(mapStateToProps)(
  translate('translations')(withCookies(withRouter(PathwayContainer)))
)
